import { useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import appstore from "../../../assets/icon/appstore.png";
import ggplay from "../../../assets/icon/ggplay.png";
import imageBanner from "../../../assets/images/banner.png";
import imgE3 from "../../../assets/images/imgE3.png";
import Banner from "../../../components/Banner/Banner";
import DropdownCustom from "../../../components/ui/Dropdown";
import { ROUTES } from "../../../constants/routers";
import "./FeeSchedule";
import Table1 from "./Tabel1/Table1";
import Table2 from "./Tabel2/Table2";
import Table3 from "./Tabel3/Table3";
import Table4 from "./Tabel4/Table4";
import Table5 from "./Tabel5/Table5";
import Table6 from "./Tabel6/Table6";
import Table7 from "./Tabel7/Table7";
import Table8 from "./Tabel8/Table8";

const FeeSchedule = () => {
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="section-top">
            <div className="container">
                <Banner
                    img={imgE3}
                    bgr={imageBanner}
                >
                    <h2 className="fs-1 fw-bold">Sản phẩm - dịch vụ</h2>
                    <p className="fs-6 my-3">HPay cung cấp các giải pháp trung gian thanh toán toàn diện với nhiều dịch vụ và tiện ích cho tất cả khách hàng.</p>
                    <div className="bn-app d-flex gap-3">
                        <a href="https://play.google.com/store/apps/details?id=com.hpay.ewalletapp" target="_blank">
                            <img src={ggplay} alt={'gg'} />
                        </a>
                        <a href="https://apps.apple.com/vn/app/hpay/id6479690061" target="_blank">
                            <img src={appstore} alt={'app'} />
                        </a>
                    </div>
                </Banner>
                <div className="section-top-big">
                    <div className="row">
                        <div className="col-lg-3 d-none d-lg-block">
                            <ul className="list-unstyled">
                                <li>
                                    <Link to={ROUTES.PAYMENT_GATEWAYS} className="link-hover-tab">
                                        Cổng thanh toán
                                    </Link>
                                </li>
                                <li className="mt-2">
                                    <Link to={ROUTES.E_WALLETS} className="link-hover-tab">
                                        Ví điện tử
                                    </Link>
                                </li>
                                <li className="mt-2">
                                    <Link to={ROUTES.SERVICES} className="link-hover-tab">
                                        Dịch vụ Thu hộ
                                    </Link>
                                </li>
                                <li className="mt-2">
                                    <Link to={ROUTES.FEE_SCHEDULE} className="link-hover-tab active">
                                        Biểu phí
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-9 col-12">
                            <h2 className="fw-bold mt-lg-0 fs-1">Biểu phí HPAY</h2>
                            <div className="d-lg-none">
                                <DropdownCustom items={[
                                    { label: "Cổng thanh toán", value: ROUTES.PAYMENT_GATEWAYS },
                                    { label: "Ví điện tử", value: ROUTES.E_WALLETS },
                                    { label: "Dịch vụ Thu hộ", value: ROUTES.SERVICES },
                                    { label: "Biểu phí", value: ROUTES.FEE_SCHEDULE }
                                ]

                                }
                                    onSelect={(item) => navigate(item.value)}
                                >
                                    <div className="btn-dropdown mt-3">
                                        Biểu phí
                                        <FaChevronDown className="text-secondary ms-2" />
                                    </div>
                                </DropdownCustom>
                            </div>
                            <div className="my-4">
                                <div>
                                    <Table1 />
                                </div>
                                <div>
                                    <Table2 />
                                </div>
                                <div>
                                    <Table3 />
                                </div>
                                <div>
                                    <Table4 />
                                </div>
                                <div>
                                    <Table5 />
                                </div>
                                <div>
                                    <Table6 />
                                </div>
                                <div>
                                    <Table7 />
                                </div>
                                <div>
                                    <Table8 />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeeSchedule;
